export default __webpack_public_path__ + "static/media/edit.e6eb4b6d.svg";